import {
    GET_SAP_OCPI_PARTNER_LIST,
    FETCH_SAP_OCPI_CREDS_LIST,
    ADD_SAP_OCPI_PARTNER_LIST,
    UPDATE_SAP_OCPI_PARTNER_LIST,
    DELETE_SAP_OCPI_PARTNER_LIST,
    GENERATE_SAP_INVOICES_WITH_GST,
    TRIGGER_LOGITAX_OCPI_INVOICES,
    FETCH_SAP_INVOICES_WITH_GST,
    PAGINATION_INFO,
    FETCH_SAP_STATION_DETAILS,
    UPDATE_SAP_STATION_DETAILS
} from 'actions/sap';

const initialState = {
    isLoading: false,
    sapData: [],
    sapCredData: [],
    sapInvoiceData: [],
    logitaxData: [],
    sapFetchedData: [],
    sapStationDetails: [],
    page: 1,
    limit: 10,
    totalPages: 1,
    total: 1,
};

const sapData = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_SAP_OCPI_PARTNER_LIST.REQUEST:
        case FETCH_SAP_OCPI_CREDS_LIST.REQUEST:
        case ADD_SAP_OCPI_PARTNER_LIST.REQUEST:
        case UPDATE_SAP_OCPI_PARTNER_LIST.REQUEST:
        case DELETE_SAP_OCPI_PARTNER_LIST.REQUEST:
        case FETCH_SAP_INVOICES_WITH_GST.REQUEST:
            {
                return { ...state, isLoading: true };
            }

        case TRIGGER_LOGITAX_OCPI_INVOICES.REQUEST:
            {
                return { ...state, isLoading: false };
            }

        case GENERATE_SAP_INVOICES_WITH_GST.REQUEST:
            {
                return { ...state, isLoading: false };
            }

        case PAGINATION_INFO.REQUEST:
            {
                return { ...state, isLoading: true };
            }

        case FETCH_SAP_STATION_DETAILS.REQUEST:
            {
                return { ...state, isLoading: true };
            }

        case UPDATE_SAP_STATION_DETAILS.REQUEST:
            {
                return { ...state, isLoading: true };
            }

        case GET_SAP_OCPI_PARTNER_LIST.SUCCESS:
            {
                return {
                    ...state,
                    isLoading: false,
                    sapData: payload.data,
                    page: payload.page,
                    limit: payload.limit,
                    totalPages: payload.totalPages,
                    total: payload.totalResults,
                };
            }

        case GENERATE_SAP_INVOICES_WITH_GST.SUCCESS:
            {
                return {
                    ...state,
                    isLoading: false,
                    sapInvoiceData: payload.data,
                    page: payload.page,
                    limit: payload.limit,
                    totalPages: payload.totalPages,
                    total: payload.totalResults,
                };
            }

        case FETCH_SAP_INVOICES_WITH_GST.SUCCESS:
            {
                return {
                    ...state,
                    isLoading: false,
                    sapFetchedData: payload.data,
                    page: payload.page,
                    limit: payload.limit,
                    totalPages: payload.totalPages,
                    total: payload.totalResults,
                };
            }

        case ADD_SAP_OCPI_PARTNER_LIST.SUCCESS:
        case UPDATE_SAP_OCPI_PARTNER_LIST.SUCCESS:
        case DELETE_SAP_OCPI_PARTNER_LIST.SUCCESS:
            {
                return { ...state, isLoading: false };
            }

        case FETCH_SAP_OCPI_CREDS_LIST.SUCCESS:
            return {
                ...state,
                isLoading: false,
                sapCredData: payload.data,
            }

        case TRIGGER_LOGITAX_OCPI_INVOICES.SUCCESS:
            return {
                ...state,
                isLoading: false,
                logitaxData: payload.data,
            }
        case PAGINATION_INFO.SUCCESS:
            {
                return {
                    ...state,
                    isLoading: false,
                    sapData: payload.data,
                    page: payload.page || 1,
                    limit: payload.pageSize,
                    totalPages: payload.totalPages,
                    total: payload.totalCount,
                };
            }


        case FETCH_SAP_STATION_DETAILS.SUCCESS: {
            const totalPages = Math.ceil(payload.total / payload.limit);
            return {
                ...state,
                isLoading: false,
                sapStationDetails: payload.results,
                page: payload.page,
                limit: payload.limit,
                totalPages,
                total: payload.total,
            };
        }

        case UPDATE_SAP_STATION_DETAILS.SUCCESS:
            {
                return { ...state, isLoading: false };
            }

        case GET_SAP_OCPI_PARTNER_LIST.FAIL:
        case FETCH_SAP_OCPI_CREDS_LIST.FAIL: {

            return { ...state, isLoading: false };
        }

        case ADD_SAP_OCPI_PARTNER_LIST.FAIL:
        case UPDATE_SAP_OCPI_PARTNER_LIST.FAIL:
        case DELETE_SAP_OCPI_PARTNER_LIST.FAIL:
            {
                return { ...state, isLoading: false };
            }


        case GENERATE_SAP_INVOICES_WITH_GST.FAIL:
            {
                return { ...state, isLoading: false };
            }


        case FETCH_SAP_INVOICES_WITH_GST.FAIL:
            {
                return { ...state, isLoading: false };
            }

        case TRIGGER_LOGITAX_OCPI_INVOICES.FAIL:
            {
                return { ...state, isLoading: false };
            }
        case PAGINATION_INFO.FAIL:
            {
                return { ...state, isLoading: false };
            }

        case FETCH_SAP_STATION_DETAILS.FAIL:
        case UPDATE_SAP_STATION_DETAILS.FAIL:
            {
                return { ...state, isLoading: false };
            }

        default:
            return { ...state };
    }
};
export default sapData;
